export default {};
export const MIMEParams = {};
export const MIMEType = {};
export const TextDecoder = {};
export const TextEncoder = {};
export const _extend = {};
export const aborted = {};
export const callbackify = {};
export const debug = {};
export const debuglog = {};
export const deprecate = {};
export const format = {};
export const formatWithOptions = {};
export const getSystemErrorName = {};
export const inherits = () => undefined;
export const inspect = {};
export const isArray = {};
export const isBoolean = {};
export const isBuffer = {};
export const isDate = {};
export const isDeepStrictEqual = {};
export const isError = {};
export const isFunction = {};
export const isNull = {};
export const isNullOrUndefined = {};
export const isNumber = {};
export const isObject = {};
export const isPrimitive = {};
export const isRegExp = {};
export const isString = {};
export const isSymbol = {};
export const isUndefined = {};
export const log = {};
export const parseArgs = {};
export const parseEnv = {};
export const promisify = {};
export const stripVTControlCharacters = {};
export const styleText = {};
export const toUSVString = {};
export const types = {};